module.exports = __webpack_public_path__ + "fonts/Barlow-Bold.0cb1ab8.ttf";